export enum DiscoveryVisibility {
    Hidden,
    FliptoStaff,
    Everyone
}
